export default "__VITE_ASSET__W4s8iMBz__"